'use strict';

wbApp.controller('DuePaymentUserPaymentsCtrl', ['$scope', '$window', 'paymentsSvc', 'securitySvc',
function ($scope, $window, paymentsSvc, securitySvc) {



    $scope.relatedGridFilterOptions = {
        filterText: ""
    };

    $scope.relatedGridOptions = {
        sortInfo: { fields: ['paymentDate'], directions: ['asc'] },
        columnDefs: [
            { field: 'semesterID', displayName: "TXT_LBL_SEMESTER", cellFilter: 'semester', width: '160px' },
            { field: 'studentFullName', displayName: "TXT_LBL_STUDENT", sort: 'humanName', width: '160px' },
            { field: 'typeID', displayName: "TXT_LBL_TYPE", cellFilter: 'invoiceForType', width: '55px' },
            { field: 'subject', displayName: "TXT_LBL_SUBJECT", sort: 'locale' },
            { field: 'notes', displayName: "TXT_NOTE", sort: 'locale', smHide: true, mdHide: true },
            { field: 'value', displayName: "TXT_LBL_AMOUNT", cellFilter: 'wbCurrencyFlt', width: '100px', align: 'right' },
            { field: 'paymentTypeID', displayName: "TXT_LBL_PAYMENT", cellFilter: 'paymentType', width: '80px' },
            { field: 'paymentDate', displayName: "TXT_LBL_DATE", cellFilter: "date:'shortDate'", width: '70px' }
        ],
        dangerFn: function (row) { return row.value < 0; },
        customCmds: [
            {
                text: 'TXT_MENU_PRINT_RECEIPT',
                hide: function (row) {
                    return row.paymentTypeID !== 1 || !securitySvc.isInRole('Payment.CashReceipt') || !securitySvc.isInRole('Reports');
                },
                command: function (row) { onPrintReceipt(row.paymentID); }
            },
            {
                text: 'TXT_MENU_PRINT_INVOICE',
                hide: function () { return !securitySvc.isInRole('Reports'); },
                command: function (row) { onPrintInvoice(row.invoiceID); }
            }]
    };


    function onPrintReceipt(paymentID) {
        if (securitySvc.isInRole('Payment.CashReceipt') && securitySvc.isInRole('Reports')) {
            $window.open('/Admin/Report/CashReceipt?PaymentID=' + paymentID,
                '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
        }
    }

    function onPrintInvoice(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    var isActive = false;
    var loaded = false;
    $scope.parentID = null;
    $scope.relatedPayments = [];

    $scope.$on('selectedDuePaymentChanged', function (e, data) {

        if (data) {
            if (data.parentID !== $scope.parentID || !loaded) {
                $scope.parentID = data.parentID;
                if (isActive) {
                    $scope.relatedPayments = paymentsSvc.getAllForUserAsync(data.parentID);
                    loaded = true;
                } else {
                    loaded = false;
                }
            }
        } else {
            $scope.relatedPayments.length = 0;
            loaded = false;
        }
    });


    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 2) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.parentID) {
                    $scope.relatedPayments = paymentsSvc.getAllForUserAsync($scope.parentID);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });
   
}]);